<div id="wrap" (click)="screenClick()"  *ngIf="!userType">
  <div class="common-back-btn"  (click)="close($event)"></div>
  <app-case-practice-pro-nav [steps]="2" [theme]="theme" [exerciseMetaId]='exerciseMetaId' [MaxProgress]="maxProgress" [progress]="currentProgress"></app-case-practice-pro-nav>
  <div id="reviewBtn" class="fontSize16" (click)="reviewConversation($event)" [@boxAnimation]="reviewBtnStatus">
    场景回顾
  </div>

  <div id="reviewBox">
    <!--<div id="reviewBoxTitle" class="fontSize18 lineHeight24" >-->
      <!--场景回顾-->
    <!--</div>-->
    <p class="excellentDemonstrationTitle flowerBorderBottom">场景回顾</p>
    <div class="reviewItem" *ngFor="let item of conversationHistory;let i=index">
      <div class="reviewRole fontSize14 lineHeight24" *ngIf="item.type!=9 && item.role != '导师点评'" [ngClass]="{'reviewRole1':item.role=='秦飞','reviewRole2':item.role=='我'}">
        {{item.role}}
      </div>
      <div class="reviewComment fontSize14 lineHeight21" *ngIf="item.type!=9 && item.role != '导师点评'">
        {{item.comment}}
      </div>

      <div class="bg-lightBlue" *ngIf="item.role == '导师点评'">
        <div class="fontSize14 lineHeight24 excellentDemonstrationTitle" >
          {{item.role}}
        </div>
        <div class="reviewComment2 fontSize14 lineHeight21">
          {{item.comment}}
        </div>
      </div>

      <div class="reviewAnswerBox fontSize14 lineHeight24" *ngIf="item.type==9" (click)="reviewTableClick($event,i)">
        <div class="reviewAnswerHead">
          {{item.role}}
          <i class="fa fa-caret-up fa-lg discussionBgIcon" *ngIf="item.mode==1"></i>
          <i class="fa fa-caret-down fa-lg discussionBgIcon" *ngIf="item.mode==0"></i>
        </div>
        <div class="reviewAnswerMain reviewAnswerMain_{{item.mode}}" [innerHtml]="item.comment"></div>
      </div>
    </div>
  </div>

  <div id="shade"></div>
  <div id="closeBtn" (click)="closeTip($event)"></div>

  <img src="{{assetsRoute}}/picture/casepracticeinfluence/information.png" alt="" [@informationAnimation]="informationStatus" id="information">

  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/normal.png" alt="" id="normal" [@peopleAnimation]="normalStatus">
  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/accept.png" alt="" id="accept" [@peopleAnimation]="acceptStatus">
  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/awkward.png" alt="" id="awkward" [@peopleAnimation]="awkwardStatus">
  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/indifferent.png" alt="" id="indifferent" [@peopleAnimation]="indifferentStatus">
  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/resist.png" alt="" id="resist" [@peopleAnimation]="resistStatus">

  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/womannew.png" alt="" id="woman" [@peopleAnimation]="womanStatus">

  <img src="{{assetsRoute}}/picture/casepracticeinfluence/telephone.png" alt="" id="telephone" [@telephoneAnimation]="telephoneStatus">
  <img src="{{assetsRoute}}/picture/casepracticeinfluence/play.png" alt="" id="play" (click)="playAudio($event)" class="imgAble">
	<div [@boxAnimation]="womanMessage"  class="talkByjiManage">我来介绍一下我的经验...</div>
  <div id="playWrap">
    <div id="playText" class="fontSize18">点击听录音</div>
    <div id="playBar">
      <div id="playBarInner"></div>
    </div>
  </div>
  <div [@soldAnimation]="soldShow ? 'showSold': 'hideSold'">
    <div id="soldoutWrap">
      <div id="soldout1">
      </div>
      <div id="soldout2">
      </div>
    </div>
    <img src="{{assetsRoute}}/picture/casepracticeinfluence/finger.png" alt="" id="finger">
  </div>
  <div id="talkBox1" [@boxAnimation]="boxOneStatus">
    <div id="talkBoxContent1" class="fontSize16">
    </div>
    <div class="talkBoxContentFake fontSize16" [innerHtml]="currentFakeWord">
    </div>
    <div id="talkBoxName1" class="fontSize16">
      我
    </div>
  </div>

  <div id="talkBox2" class="talkBox2" [@boxAnimation]="boxTwoStatus">
    <div id="talkBoxContent2" class="fontSize16">
    </div>
    <div class="talkBoxContentFake fontSize16" [innerHtml]="currentFakeWord">
    </div>
    <div id="talkBoxName2" class="fontSize16 talkBoxName2">
      秦飞
    </div>
  </div>

  <div id="optionsWrap" [@optionWrapAnimation]="optionWrapStatus">
    <div class="optionTips">长按按钮进行选择</div>

    <div *ngIf="!type">
      <div class="optionItem fontSize14" id="option_{{i}}" *ngFor="let option of currentOptions;let i=index"  (touchstart)="onOptionMouseDown(i, $event)"  (touchend)="onOptionMouseUp($event)">
        {{option.description}}
        <div class="loading"><div class='dotting' id='dotting1'></div><div class='dotting' id='dotting2'></div><div class='dotting' id='dotting3'></div></div>
        <div class="pressing"><div class="pressingOption">{{option.description}}</div></div>
      </div>
    </div>

    <div *ngIf="type">
      <div class="optionItem fontSize14" id="option_{{i}}" *ngFor="let option of currentOptions;let i=index"  (mousedown)="onOptionMouseDown(i, $event)" (mouseup)="onOptionMouseUp($event)">
        {{option.description}}
        <div class="loading"><div class='dotting' id='dotting1'></div><div class='dotting' id='dotting2'></div><div class='dotting' id='dotting3'></div></div>
        <div class="pressing"><div class="pressingOption">{{option.description}}</div></div>
      </div>
    </div>

  </div>

  <div id="tutorHints" class="fontSize14" [@hintAnimation]="hintStatus">
    <div id="tutorHintsContent" [innerHtml]="currentWord">
    </div>
    <div id="tutorHintsFake" [innerHtml]="currentWord">
    </div>
  </div>

  <div id="generateReportBtn" class="fontSize18" [@boxAnimation]="buttonStatus" (click)="linkToReport()">
    生成并查看报告
  </div>

</div>

<!--访客情景模拟-->
<div id="wrap" (click)="screenClick()"  *ngIf="userType">

  <img src="{{assetsRoute}}/picture/casepracticeinfluence/information.png" alt="" [@informationAnimation]="informationStatus" id="information">

  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/normal.png" alt="" id="normal" [@peopleAnimation]="normalStatus">
  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/accept.png" alt="" id="accept" [@peopleAnimation]="acceptStatus">
  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/awkward.png" alt="" id="awkward" [@peopleAnimation]="awkwardStatus">
  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/indifferent.png" alt="" id="indifferent" [@peopleAnimation]="indifferentStatus">
  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/resist.png" alt="" id="resist" [@peopleAnimation]="resistStatus">

  <img *ngIf="boxOneStatus!='showBox'" src="{{assetsRoute}}/picture/casepracticeinfluence/womannew.png" alt="" id="woman" [@peopleAnimation]="womanStatus">

  <img src="{{assetsRoute}}/picture/casepracticeinfluence/telephone.png" alt="" id="telephone" [@telephoneAnimation]="telephoneStatus">
  <img src="{{assetsRoute}}/picture/casepracticeinfluence/play.png" alt="" id="play" (click)="playAudio($event)" class="imgAble">
  <div [@boxAnimation]="womanMessage"  class="talkByjiManage">我来介绍一下我的经验...</div>
  <div id="playWrap">
    <div id="playText" class="fontSize18">点击听录音</div>
    <div id="playBar">
      <div id="playBarInner"></div>
    </div>
  </div>
  <div [@soldAnimation]="soldShow ? 'showSold': 'hideSold'">
    <div id="soldoutWrap">
      <div id="soldout1">
      </div>
      <div id="soldout2">
      </div>
    </div>
    <img src="{{assetsRoute}}/picture/casepracticeinfluence/finger.png" alt="" id="finger">
  </div>
  <div id="talkBox1" [@boxAnimation]="boxOneStatus">
    <div id="talkBoxContent1" class="fontSize16">
    </div>
    <div class="talkBoxContentFake fontSize16" [innerHtml]="currentFakeWord">
    </div>
    <div id="talkBoxName1" class="fontSize16">
      我
    </div>
  </div>

  <div id="talkBox2" class="talkBox2" [@boxAnimation]="boxTwoStatus">
    <div id="talkBoxContent2" class="fontSize16">
    </div>
    <div class="talkBoxContentFake fontSize16" [innerHtml]="currentFakeWord">
    </div>
    <div id="talkBoxName2" class="fontSize16 talkBoxName2">
      秦飞
    </div>
  </div>

  <div id="optionsWrap" [@optionWrapAnimation]="optionWrapStatus">
    <div *ngIf="!type">
      <div class="optionItem fontSize14" id="option_{{i}}" *ngFor="let option of currentOptions;let i=index"  (touchstart)="onOptionMouseDown(i, $event)"  (touchend)="onOptionMouseUp($event)">
        {{option.description}}
        <div class="loading"><div class='dotting' id='dotting1'></div><div class='dotting' id='dotting2'></div><div class='dotting' id='dotting3'></div></div>
        <div class="pressing"><div class="pressingOption">{{option.description}}</div></div>
      </div>
    </div>

    <div *ngIf="type">
      <div class="optionItem fontSize14" id="option_{{i}}" *ngFor="let option of currentOptions;let i=index"  (mousedown)="onOptionMouseDown(i, $event)" (mouseup)="onOptionMouseUp($event)">
        {{option.description}}
        <div class="loading"><div class='dotting' id='dotting1'></div><div class='dotting' id='dotting2'></div><div class='dotting' id='dotting3'></div></div>
        <div class="pressing"><div class="pressingOption">{{option.description}}</div></div>
      </div>
    </div>
  </div>

  <div id="tutorHints" class="fontSize14" [@hintAnimation]="hintStatus">
    <div id="tutorHintsContent" [innerHtml]="currentWord">
    </div>
    <div id="tutorHintsFake" [innerHtml]="currentWord">
    </div>
  </div>

  <div id="generateReportBtn" class="fontSize18" [@boxAnimation]="buttonStatus" (click)="linkToReport()">
    生成并查看报告
  </div>

</div>

<div id="shade2" ></div>

<div id="tip2" class="fontSize16">
  <div class="tip2Txt">
    想要体验更多内容，欢迎前来注册
  </div>
  <div class="orangeTxt">「限时获取企业体验机会&关键行动分析报告」</div>
  <img src="{{assetsRoute}}/picture/learningpath/testUserLayer.png" alt="">

  <div id="tipBtn2"  (click)="try()">前往注册</div>
  <div id="backLearningMap"  (click)="returnList()">返回列表</div>

</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-main/case-practice-influence-main.component.html